<template>
  <div>
    <v-dialog v-model="removeDialog" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este template?') }}
          </div>

          <v-btn
            :disabled="removeLoading"
            class="ma-1"
            color="grey"
            text
            @click="removeDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="removeLoading"
            class="ma-1"
            color="error"
            text
            @click="removeTemplate"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <v-btn
        v-if="institution.userType != 5 && institution.userType != 4"
        dark
        class="terciary-button ma-1"
        depressed
        @click="importStandardTemplates"
      >
        Importar templates
      </v-btn>
      <v-btn
        v-if="institution.userType != 5 && institution.userType != 4"
        class="secondary-button ma-1"
        depressed
        to="/calibration/v2/template/manage"
      >
        Novo template
      </v-btn>
      <v-btn
        class="primary-button ma-1"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <div class="my-2 d-flex justify-end align-center">
          <v-text-field
            v-model="filter.search"
            placeholder="Pesquise pelo nome do Template"
            class="primary-input mt-4"
            outlined
            style="max-width: 700px"
            hide-details
            @keyup.enter=";(page = 1), list()"
          ></v-text-field>
          <v-btn
            class="ma-0 primary-button ml-2"
            depressed
            @click=";(page = 1), list()"
          >
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="templates"
      class="main-table"
      hide-default-footer
      :items-per-page="filter.pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              color="#0F3565"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              :to="`/calibration/v2/template/manage?id=${item.id}`"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              color="error"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              @click="openRemoveModal(item)"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Remover') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="filter.pageSize">
          <span> 1 - {{ filter.pageSize }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import moment from 'moment'
import institutions from '../../../Institutions/institutions'

export default {
  name: 'CalibrationV2Template',

  data() {
    return {
      templateId: null,
      removeLoading: false,
      deleteLoading: false,
      removeDialog: false,
      showFilter: false,
      loading: false,
      totalPages: null,
      templates: [],
      totalItems: null,
      sizes: [10, 25, 50],
      institution: null,
      filter: {
        page: 1,
        pageSize: 10,
      },
      page: 1,
      pageSize: 10,
      headerProps: {},
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      apiService: new ApiService(),
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.list()
  },

  methods: {
    removeTemplate() {
      this.removeLoading = true

      this.apiService
        .delete(`calibration/v2/template/${this.templateId}`)
        .then(() => {
          this.filter.page = 1
          this.removeLoading = false
          this.removeDialog = false
          this.$toast.success('Template removido com sucesso!')
          this.list()
        })
        .catch(() => {
          this.removeLoading = false
        })
    },

    openRemoveModal(item) {
      this.templateId = item.id
      this.removeDialog = true
    },

    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      else return 'Sem registro'
    },

    list() {
      this.loading = true
      this.apiService
        .get('calibration/v2/template/paginate', this.filter)
        .then((response) => {
          this.templates = response.content.data
          this.totalPages = response.content.pager.totalPages
          this.totalItems = response.content.pager.totalItems
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    importStandardTemplates() {
      this.loading = true
      this.apiService
        .post(
          `calibration/v2/template/import-standard-template/${this.filter.institutionId}`
        )
        .then((response) => {
          if (response.statusCode === 200) {
            this.$toast.success('Templates importados com sucesso')
            this.list()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },

  watch: {
    page: function () {
      this.filter.page = this.page
      this.list()
    },
    pageSize: function () {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
